import React from "react";
import { FiAward } from "react-icons/fi";
import { FrequencyType } from "../../pages/compose/ScheduleReviewPage";

// Type-safe icon wrapper
const CrownIcon = FiAward as React.FC<React.SVGProps<SVGSVGElement>>;

interface FrequencySelectorProps {
  selectedFrequency: FrequencyType;
  onFrequencyChange: (frequency: FrequencyType) => void;
  canUseWeekly: boolean;
  canUseMonthly: boolean;
}

interface FrequencyOption {
  id: FrequencyType;
  title: string;
  description: string;
  requiresPro: boolean;
}

const FREQUENCY_OPTIONS: FrequencyOption[] = [
  {
    id: "one-time",
    title: "ONE-TIME",
    description: "Send once on selected date",
    requiresPro: false,
  },
  {
    id: "weekly",
    title: "WEEKLY",
    description: "Recurring every week",
    requiresPro: true,
  },
  {
    id: "monthly",
    title: "MONTHLY",
    description: "Recurring every month",
    requiresPro: true,
  },
];

/**
 * FrequencySelector - Select send frequency
 */
const FrequencySelector: React.FC<FrequencySelectorProps> = ({
  selectedFrequency,
  onFrequencyChange,
  canUseWeekly,
  canUseMonthly,
}) => {
  const isOptionEnabled = (option: FrequencyOption): boolean => {
    if (option.id === "one-time") return true;
    if (option.id === "weekly") return canUseWeekly;
    if (option.id === "monthly") return canUseMonthly;
    return false;
  };

  return (
    <div className="su-section su-frequency-selector">
      <div className="su-frequency-header">
        <span className="su-frequency-label">SEND FREQUENCY</span>
      </div>

      <div className="su-frequency-options">
        {FREQUENCY_OPTIONS.map((option) => {
          const isEnabled = isOptionEnabled(option);
          const isSelected = selectedFrequency === option.id;

          return (
            <button
              key={option.id}
              className={`su-frequency-option ${isSelected ? "selected" : ""} ${
                !isEnabled ? "disabled" : ""
              }`}
              onClick={() => isEnabled && onFrequencyChange(option.id)}
              disabled={!isEnabled}
            >
              <div className="su-frequency-option-content">
                <span className="su-frequency-option-title">{option.title}</span>
                <span className="su-frequency-option-description">
                  {option.description}
                </span>
              </div>

              {option.requiresPro && !isEnabled && (
                <div className="su-frequency-pro-badge">
                  <CrownIcon className="w-3 h-3" />
                  <span>PRO</span>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FrequencySelector;

